import * as Dfns from 'date-fns/fp';
import { TODAY } from '@blisspointmedia/bpm-types/dist/RelativeDatePicker';

// DEV-24557: tinuititest's HROAS run is a copy of DSW's data, so its feature_ids only resolve
// against DSW's own mmm_features rows (see TINUITITEST_FEATURE_MAP_PROXY_CID's usage).
export const TINUITITEST_CID = 'tinuititest';
export const TINUITITEST_FEATURE_MAP_PROXY_CID = 'dsw';

export const getEfficientFrontierDefaultDates = (): {
  start: string;
  end: string;
  planLength: number;
} => ({
  start: Dfns.format('yyyy-MM-dd')(Dfns.subMonths(1, new Date())),
  end: TODAY,
  planLength: 4
});
